import { useTheme, useTranslation } from '@/contexts';
import styles from './ThemeToggle.module.css';

/** Солнце — день, месяц со звёздами — ночь. Кнопка показывает, куда переключит. */
function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden focusable="false">
      <circle cx="12" cy="12" r="4.4" fill="#fbbf24" stroke="#f59e0b" strokeWidth="1.4" />
      <g stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round">
        <path d="M12 1.8v2.6M12 19.6v2.6M1.8 12h2.6M19.6 12h2.6" />
        <path d="M4.8 4.8l1.9 1.9M17.3 17.3l1.9 1.9M19.2 4.8l-1.9 1.9M6.7 17.3l-1.9 1.9" />
      </g>
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden focusable="false">
      <path
        d="M20.4 14.8A8.6 8.6 0 0 1 9.2 3.6 8.6 8.6 0 1 0 20.4 14.8Z"
        fill="#93c5fd"
        stroke="#3b82f6"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="17.4" cy="4.6" r="1.1" fill="#3b82f6" />
      <circle cx="20.6" cy="8.4" r="0.75" fill="#60a5fa" />
      <circle cx="14.6" cy="2.6" r="0.6" fill="#60a5fa" />
    </svg>
  );
}

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const label = t(theme === 'dark' ? 'theme.toLight' : 'theme.toDark');

  return (
    <button
      type="button"
      className={styles.button}
      onClick={toggleTheme}
      title={label}
      aria-label={label}
    >
      {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}
